"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OvernightLocationHeaderPanelWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var OvernightLocationHeaderPanelWidget = /** @class */ (function (_super) {
    __extends(OvernightLocationHeaderPanelWidget, _super);
    function OvernightLocationHeaderPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicles = _this.props.interaction.vehicles;
        _this.vehiclesText = "";
        _this.vehicles.forEach(function (vehicle, index) {
            _this.vehiclesText += _this.capitalize(vehicle.make) + ", " + _this.capitalize(vehicle.model) + " (" + vehicle.registrationNumber + ")";
            if (index < _this.vehicles.length - 2 && _this.vehicles.length > 2) {
                _this.vehiclesText += ", ";
            }
            else if (index === _this.vehicles.length - 2) {
                _this.vehiclesText += " and ";
            }
            else if (index === _this.vehicles.length - 1) {
                _this.vehiclesText += ".";
            }
        });
        return _this;
    }
    OvernightLocationHeaderPanelWidget.prototype.render = function () {
        return (React.createElement("div", { className: "panel font-weight-light banner banner-info" },
            React.createElement("p", null,
                "Heads up - please ",
                React.createElement("span", { className: "font-weight-bold" }, "check overnight location"),
                " for ",
                this.vehiclesText)));
    };
    OvernightLocationHeaderPanelWidget.prototype.capitalize = function (text) {
        return text != null ?
            text.toLowerCase().split(' ').map(function (s) { return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase(); }).join(' ') : "";
    };
    return OvernightLocationHeaderPanelWidget;
}(plugin_journey_1.WidgetBase));
exports.OvernightLocationHeaderPanelWidget = OvernightLocationHeaderPanelWidget;
//# sourceMappingURL=OvernightLocationHeaderPanelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/falconSelfService/OvernightLocationHeaderPanelWidget.js
// module id = 3277
// module chunks = 0